import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => {
  const { marginLR, left } = theme.mixins;
  return {
    wrapper: {
      width: '100%',
      minHeight: pxToRem(169),
      backgroundColor: theme.palette.action.disabledBackground,

      [theme.breakpoints.up('lg')]: {
        width: '47%',
      },
    },
    roomHeader: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',

      '& .MuiTypography-body2': {
        fontFamily: theme.custom.fontFamily.primaryBold,
      },
    },
    guestInfoSection: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',

      '& .MuiFormControl-root label .MuiTypography-root': {
        fontFamily: theme.custom.fontFamily.primaryBold,
      },
      '& fieldset:last-of-type': {
        marginRight: 0,
      },
      '& .makeStyles-inputLabel-179': {
        top: pxToRem(-15),
      },
      '& .makeStyles-inputLabel-179 + .MuiInput-formControl': {
        marginTop: 0,
      },
    },
    roomWrapper: {
      display: 'flex',
      flexDirection: 'column',
      ...marginLR(pxToRem(17), pxToRem(17)),
      paddingTop: pxToRem(15),
      paddingBottom: pxToRem(15),
      borderBottom: theme.borders.divider,
    },
    addroomSection: {
      ...marginLR(pxToRem(17), pxToRem(17)),
      paddingTop: pxToRem(15),
      paddingBottom: pxToRem(15),
    },
    removeLink: {
      color: theme.palette.common.SeaPort,
    },
    addRoomLink: {
      position: 'relative',

      '& span': {
        color: theme.mixins.AbuDhabiOrange(),
        ...marginLR(pxToRem(16)),
        fontFamily: theme.custom.fontFamily.primaryBold,

        '&:before': {
          position: 'absolute',
          content: "'+'",
          ...left(0),
        },
      },
    },
  };
});

export default useStyles;
